if (!customElements.get('scrolly-first-step')) {
  customElements.define(
    'scrolly-first-step',
    class ScrollyFirstStep extends HTMLElement {
      constructor () {
        super();
        this.container = this.querySelector('.scrolly-video-image');
        this.videoWrapper = this.querySelector('.scrolly-video-wrapper');
        if (!this.container) {
          return;
        }
        this.videoContainer = null;
        if (this.videoWrapper) {
          this.videoWrapper.style.opacity = 0;
          this.videoContainer = this.videoWrapper.querySelector('#scrolly-video');
        }

        this.compareSection = document.querySelector('#parallax .parallax-cards-wrapper');
        this.leftBottomImage = null;
        if (this.compareSection) {
          this.leftBottomImage = this.compareSection.querySelector('.parallax-card-left .parallax-card-image');
          if (this.leftBottomImage) {
            this.leftBottomImage.style.opacity = 0;
          }
        }
        this.button = this.querySelector('.scrolly-video-icon');
        this.videoObserver = null;
        this.compareObserver = null;
        this.topObserver = null;
      }

      connectedCallback () {
        let keyframes = {
         width: [
            '11.3vw',
            '11.3vw',

            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',
            'max(17.5vw, 197px)',

            '14.7rem',
            '14.7rem',
            '14.7rem'
         ],
          top: [
            '19.4rem',

            '20.6vh',
            '20.6vh',
            '20.6vh',
            '20.6vh',
            '20.6vh',
            '20.6vh',
            '20.6vh',
            '20.6vh',
            '20.6vh',
            '20.6vh',
            '20.6vh',
            '20.6vh',
            '20.6vh',
            '20.6vh',
            '20.5vh',
            '20.5vh',

            '15.4rem',
            '15.4rem',
            '15.4rem',
          ],
          transform: [
            'transform: rotate(0deg) translateX(max(16.5vw, 27rem)',

            'rotate(0deg) translateX(calc(9% + var(--middle-offset))) translateY(0%)',
            'rotate(0deg) translateX(calc(9% + var(--middle-offset))) translateY(0%)',
            'rotate(0deg) translateX(calc(9% + var(--middle-offset))) translateY(0%)',
            'rotate(0deg) translateX(calc(9% + var(--middle-offset))) translateY(0%)',
            'rotate(0deg) translateX(calc(9% + var(--middle-offset))) translateY(0%)',

            'rotate(0deg) translateX(calc(9% + var(--middle-offset))) translateY(0%)',
            'rotate(0deg) translateX(calc(9% + var(--middle-offset))) translateY(0%)',
            'rotate(0deg) translateX(calc(9% + var(--middle-offset))) translateY(0%)',
            'rotate(0deg) translateX(calc(9% + var(--middle-offset))) translateY(0%)',
            'rotate(0deg) translateX(calc(9% + var(--middle-offset))) translateY(0%)',
            'rotate(0deg) translateX(calc(9% + var(--middle-offset))) translateY(0%)',
            'rotate(0deg) translateX(calc(9% + var(--middle-offset))) translateY(0%)',
            'rotate(0deg) translateX(calc(13.3% + var(--middle-offset))) translateY(0%)',
            'rotate(0deg) translateX(calc(13.3% + var(--middle-offset))) translateY(0%)',

            'rotate(0deg) translateX(calc(-58% + var(--bottom-offset))) translateY(0%)',
            'rotate(0deg) translateX(calc(-58% + var(--bottom-offset))) translateY(0%)',
            'rotate(0deg) translateX(calc(-58% + var(--bottom-offset))) translateY(0%)'
          ],
        };

        if (this.isMobile()) {
          keyframes = {
            top: [
              '25.5rem', '12.8rem', '12.8rem',

              '12.8rem', '12.8rem', '12.8rem',
              '12.8rem', '12.8rem', '12.8rem',
              '12.8rem',
            ],
            transform: [
              'rotate(0)',
              'rotate(0)',
              'rotate(0)',

              'rotate(0)',
              'rotate(0)',
              'rotate(0)',
              'rotate(0)',
              'rotate(0)',
              'rotate(0)',

              'rotate(7.46deg)',
              'rotate(0)',
            ],
            width: [
              '35.07vw', '35.07vw', '35.07vw',

              '33.07vw', '33.07vw', '33.07vw',

              '13.52rem'],
            left: [
              '0',
              '0',
              '0',

              '0',
              '0',
              '0',
              '5%',
              '5%',
              '5%',

              '-87px'],
          };
        } else if (this.isTablet()) {
          keyframes = {
            top: ['25.5rem', '12.5rem'],
            transform: ['rotate(0)', 'rotate(0)', 'rotate(7.46deg)', 'rotate(0)'],
            width: ['max(17.5vw, 197px)', 'max(17.5vw, 197px)', 'max(17.5vw, 197px)', '24.4rem'],
            left: ['0', '0', '0', '-max(17.5vw, 197px)'],
          };
        }
        try {
          this.container.animate(
            keyframes,
            {
              duration: 1500,
              fill: 'both',
              timeline: new ViewTimeline({ subject: this }),
              rangeStart: { rangeName: 'contain', offset: CSS.percent(-2) },
              rangeEnd: { rangeName: 'contain', offset: CSS.percent(120) },
            });
        } catch ({ name, message }) {
          console.error(name, message);

        }

        this.container.style.opacity = 1;
        if (this.button) {
          this.button.addEventListener('click', this.goToVideo.bind(this));
          this.topObserver = new IntersectionObserver(entries => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  if (this.videoWrapper) {
                   this.videoWrapper.style.opacity = 0;
                  }
                  if (this.leftBottomImage) {
                    this.leftBottomImage.style.opacity = 0;
                  }
                  this.container.style.opacity = 1;
                  this.button.style.opacity = 1;
                } else {
                  this.button.style.opacity = 0;
                }
              });
            },
            { threshold: 0.1 },
          );
          this.topObserver.observe(this.button);
        }
        if (this.videoWrapper) {
          if (this.videoContainer) {
            this.videoContainer.addEventListener('scrolledToStart', this.hideVideo.bind(this));
            this.videoContainer.addEventListener('startScrolling', this.showVideo.bind(this));
          }
        }

        if (this.compareSection && this.leftBottomImage) {
          const threshold = this.isMobile() ? 0.5 : 1.0;

          this.compareObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const cards = this.compareSection.querySelectorAll('.parallax-card');
                if (entry.isIntersecting) {
                  this.container.style.opacity = 0;
                  this.leftBottomImage.style.opacity = 1;
                  document.querySelector('sticky-header').style.opacity = 0;
                  cards.forEach((card) => {
                    card.querySelector('.parallax-card-description').classList.add('animated');
                    card.querySelector('.parallax-card-dot-wrapper').classList.add('animated');
                  });
                } else {
                  const boundingClientRect = entry.target.getBoundingClientRect();
                  if (boundingClientRect.top > 0) {
                    this.container.style.opacity = 1;
                    this.leftBottomImage.style.opacity = 0;
                    document.querySelector('sticky-header').style.opacity = 1;
                    cards.forEach((card) => {
                      card.classList.remove('animated');
                      cards.forEach((card) => {
                        card.querySelector('.parallax-card-description').classList.remove('animated');
                        card.querySelector('.parallax-card-dot-wrapper').classList.remove('animated');
                      });
                    });
                  }
                }
              },
            );
          }, { threshold: threshold });
          this.compareObserver.observe(document.querySelector('.paralax-bottom-delimiter'));
        }
      }

      hideVideo () {
        this.videoWrapper.style.opacity = 0;
        this.container.style.opacity = 1;
        this.button.style.opacity = 1;

      }

      showVideo () {
        if (this.isMobile()) {
          this.videoWrapper.style.opacity = 1;
         this.container.style.opacity = 0;
        } else {
          this.videoWrapper.style.opacity = 1;
         this.container.style.opacity = 0;
        }
        this.button.style.opacity = 0;
      }

      goToVideo () {
        this.videoContainer?.querySelector('.scrolly-video-point').
          scrollIntoView({ behavior: 'smooth', block: 'start' });

      }

      disconnectCallback () {
        this.videoObserver !== null ? this.videoObserver.unobserve() : '';
        this.compareObserver !== null ? this.compareObserver.unobserve() : '';
        this.topObserver !== null ? this.topObserver.unobserve() : '';
        if (this.button) {
          this.button.removeEventListener('click', this.goToVideo.bind(this));
        }
        if (this.videoContainer) {
          this.videoContainer.removeEventListener('scrolledToStart', this.hideVideo.bind(this));
          this.videoContainer.removeEventListener('startScrolling', this.showVideo.bind(this));
        }
      }

      isMobile () {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      isTablet () {
        return window.matchMedia('(max-width: 989px)').matches;
      }
    },
  );
}
